import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest, takeMaybe } from "typed-redux-saga";
import { Action, AnyAction } from "typescript-fsa";

import { Activity, ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { validateActivityForSave } from "../../../utilities/validationUtils";
import { CUSTOM_SAVE, CUSTOM_SAVE_AND_CLOSE } from "../../../utilities/variables/customEventNames";
import { executeBusy, reloadTaskAndAntragActivity } from "../../../utilities/workflowUtils";

function isSaveAction(action: AnyAction): action is Action<{
	readonly activityId: string;
	readonly engineEvent: Action<Events.EventButtonPayload>;
}> {
	return (
		FormEngineActions.event.match(action) &&
		Events.eventButtonTriggered.match(action.payload.engineEvent) &&
		(action.payload.engineEvent.payload.name === CUSTOM_SAVE ||
			action.payload.engineEvent.payload.name === CUSTOM_SAVE_AND_CLOSE)
	);
}

function isSaveCloseAction(action: AnyAction): action is Action<{
	readonly activityId: string;
	readonly engineEvent: Action<Events.EventButtonPayload>;
}> {
	return isSaveAction(action) && action.payload.engineEvent.payload.name === CUSTOM_SAVE_AND_CLOSE;
}

export function* customSaveSaga(): SagaIterator<void> {
	yield* takeLatest(isSaveAction, function* (action) {
		yield* call(executeBusy, function* () {
			const activity: Activity | undefined = yield* select(
				ActivitySelectors.activityById(action.payload.activityId)
			);

			if (!activity) {
				return;
			}

			const isValid = yield* call(validateActivityForSave, activity.id);

			if (isValid) {
				yield* put(ActivityActions.save.started({ activityId: activity.id }));
				yield* takeMaybe(function (action: AnyAction): boolean {
					return ActivityActions.save.done.match(action) && action.payload.params.activityId === activity.id;
				});

				if (isSaveCloseAction(action)) {
					yield* put(ActivityActions.cancel({ activityId: activity.id }));
				}
				// After saving, if the activity is not closed, both the antragActivity's and the taskDetailActivity's
				// data has to be reloaded to ensure both are in the correct state.
				else {
					yield* call(reloadTaskAndAntragActivity);
				}
			}
		});
	});
}
